









import { Component, Prop, Vue } from "vue-property-decorator";
@Component
export default class CalcCardNotes extends Vue {
    @Prop({ default: () => [] }) notes: string[];
    @Prop(Boolean) main: boolean; // shown on IssueOther success=true screen
    get styles() {
        if (!this.main) return "";
        return "margin-left: 12px;font-size: 14px;";
    }
}
